export default __webpack_public_path__ + "dc4fd13eb4deb2753db4f3aa6d5cdcd8.png";